import { api } from "@/api";
import { AddBettingMarketMappingParams, BettingMarketMappingDto } from "@/types/ApiResponses/BettingMarket";

export const addBettingMarketMapping = async (
  params: AddBettingMarketMappingParams
): Promise<BettingMarketMappingDto> => {
  const { marketId, ...body } = params;
  const res = await api.client.post(`/betting-markets-new/${marketId}/mappings`, body);
  return res.data;
};
